import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  navigate(e) {
    window.location.href = e.currentTarget.value
  }
}
